<template>
   <!-- page-wrapper Start-->
    <div class="page-wrapper">
        <div class="container-fluid">
            <!-- sign up page start-->
            <div class="authentication-main">
                <div class="row">
                    <div class="col-sm-12 p-0">
                        <div class="auth-innerright">
                            <div class="authentication-box">
                                <div class="card p-3">
                                    <div class="text-center mb-2"><img src="../../assets/images/hor-th_100.png" alt=""></div>
                                    <h5 class="text-center text-info f-w-600 " style="font-size: 20px;">Upload CSV file to Cloud Firebase</h5>                              
                                    <div class="row">
                                        <div class="col-sm-12">
                                            <div class=" card mt-4 mx-2">
                                                <span class="col-form-label text-primary f-w-600 pt-1" role="button">
                                                    Click to browse a csv file(with 1st row as header) and then auto upload to cloud firebase.
                                                </span>
                                                <input id="fileInputId" name="file" type="file" accept="text/csv" class="file" ref="fileInput" @change="onFileSelect"/>
                                            </div>
                                            <div class=" card mt-4 mx-2">
                                                <span class="col-form-label text-danger f-w-600 pt-1" role="button">
                                                    Warning : Redo importing process, it will cause to duplicate data in database.
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- sign up page ends-->
        </div>
    </div>
    <!-- page-wrapper Ends-->
</template>

<script>

import {mergeCSV } from "../../firebase"
export default {
    name: 'importCSV',

    data() {
        return{
            files : [],
            fileType : '',
            isDragging: false,
        }
    },
    methods: {
        async onFileSelect(event){
            const selFiles = event.target.files;
            const fileName = selFiles[0].name.split(".")[0]
            console.log(`selFiles, name.csv => ${fileName}`)
            mergeCSV(fileName, selFiles[0], (res)=>{
                if (res === 'success') {
                    this.$toasted.show('Data was uploaded to Firebase successfully.', {theme: 'bubble', type: 'success' , position: 'bottom-center', duration: 10000});
                } else {
                    this.$toasted.show( 'Failed to upload data.', {theme: 'bubble',   position: 'bottom-center',   type: 'error', duration: 10000});
                }
            })
        },
    }
}
</script>
